import React, { createContext, useState, useContext, useEffect, useMemo } from "react";
import en from "./languages/en.jsx";
import fr from "./languages/fr.jsx";

const LanguageContext = createContext();

const translationsMap = {
  en,
  fr,
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    const storedLanguage = localStorage.getItem("selectedLanguage");
    if (storedLanguage && (storedLanguage === "en" || storedLanguage === "fr")) {
      setLanguage(storedLanguage);
    }
  }, []);

  const handleLanguageChange = (newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem("selectedLanguage", newLanguage);
  };

  const currentTranslations = useMemo(() => {
    return translationsMap[language] || en;
  }, [language]);

  // Expose translations and a basic translate helper if needed
  const value = useMemo(() => ({
    language,
    handleLanguageChange,
    t: currentTranslations,
  }), [language, currentTranslations]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
